import {
  RequireIsVideoLabellingUser,
  RequireIsVideoLabelReviewer,
  RequirePermissions,
} from "./authentication";
import { Route, Routes } from "react-router";
import { useEffect } from "react";
import { getReplay } from "@sentry/react";
import { RequireFeatureFlagsPage } from "./authentication";
import { IdentifyEventsPage } from "components/identifyEventsTool/IdentifyEventsPage";
import { IdentifyEventsTool } from "components/identifyEventsTool/tool/IdentifyEventsTool";
import {
  ManualReviewPage,
  ManualReviewLocationPicker,
} from "components/manualReview/ManualReviewPage";
import {
  TargetedReviewPage,
  TargetedReviewLocationPicker,
} from "components/targetedReview/TargetedReviewPage";
import {
  ViewLabelsPage,
  ViewLabelsLocationPicker,
} from "components/viewLabelsReview/ViewLabelsPage";
import { AssignReviewersPage } from "components/manualReview/assignReviewers/AssignReviewersPage";
import { HotkeyProvider } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/HotkeyContext";
import { AltToggleModeProvider } from "components/scrapEyeLabelling/hooks/useAltToggleMode";
import { ProvideLabellingHotkeys } from "components/videoLabelling/hotkeys";
import { ProvideScrapEyeMetadata } from "contexts/scrapEyeMetadata";
import { ViewerLocationPicker } from "components/viewer/ViewerLocationPicker";
import { ViewerPage } from "components/viewer/ViewerPage";
import { LoadingWindowEditorPage } from "components/loadingWindowEditor/LoadingWindowEditorPage";
import { LocationExceptionalStatusPage } from "components/locationExceptionalStatus/LocationExceptionalStatusPage";
import { HeatIssuesPage } from "components/scrapEyeDataDashboard/heatIssues/HeatIssuesPage";
import { CommentReviewPage } from "components/commentReview/CommentReviewPage";

export const LabellingToolRoutes = () => {
  useEffect(() => {
    void getReplay()?.stop();
  }, []);

  return (
    <RequireFeatureFlagsPage featureFlags={["scrap_eyes"]}>
      <RequirePermissions
        permissions={["video_labelling", "video_label_reviewing"]}
      >
        <ProvideScrapEyeMetadata>
          <ProvideLabellingHotkeys>
            <AltToggleModeProvider>
              <Routes>
                <Route
                  path="/identify-events"
                  element={
                    <RequireIsVideoLabellingUser>
                      <HotkeyProvider>
                        <IdentifyEventsPage />
                      </HotkeyProvider>
                    </RequireIsVideoLabellingUser>
                  }
                />
                <Route
                  path="/identify-events/player/:location"
                  element={
                    <RequireIsVideoLabellingUser>
                      <IdentifyEventsTool />
                    </RequireIsVideoLabellingUser>
                  }
                />
                <Route
                  path="/manual-review"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <ManualReviewLocationPicker />
                    </RequireIsVideoLabelReviewer>
                  }
                />
                <Route
                  path="/manual-review/:location"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <ManualReviewPage />
                    </RequireIsVideoLabelReviewer>
                  }
                />
                <Route
                  path="/manual-review/:location/assign-reviewers"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <AssignReviewersPage />
                    </RequireIsVideoLabelReviewer>
                  }
                />
                <Route
                  path="/targeted-review"
                  element={
                    <RequireFeatureFlagsPage featureFlags={["targeted_review"]}>
                      <RequireIsVideoLabelReviewer>
                        <TargetedReviewLocationPicker />
                      </RequireIsVideoLabelReviewer>
                    </RequireFeatureFlagsPage>
                  }
                />
                <Route
                  path="/targeted-review/:location"
                  element={
                    <RequireFeatureFlagsPage featureFlags={["targeted_review"]}>
                      <RequireIsVideoLabelReviewer>
                        <TargetedReviewPage />
                      </RequireIsVideoLabelReviewer>
                    </RequireFeatureFlagsPage>
                  }
                />
                <Route
                  path="/view-labels"
                  element={
                    <RequireIsVideoLabellingUser>
                      <ViewLabelsLocationPicker />
                    </RequireIsVideoLabellingUser>
                  }
                />
                <Route
                  path="/view-labels/:location"
                  element={
                    <RequireIsVideoLabellingUser>
                      <ViewLabelsPage />
                    </RequireIsVideoLabellingUser>
                  }
                />
                <Route path="/viewer" element={<ViewerLocationPicker />} />
                <Route path="/viewer/:location" element={<ViewerPage />} />
                <Route
                  path="/loading-window-editor"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <LoadingWindowEditorPage />
                    </RequireIsVideoLabelReviewer>
                  }
                />
                <Route
                  path="/heat-issues"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <HeatIssuesPage />
                    </RequireIsVideoLabelReviewer>
                  }
                />
                <Route
                  path="/comment-review"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <CommentReviewPage />
                    </RequireIsVideoLabelReviewer>
                  }
                />
                <Route
                  path="/location-exceptional-status"
                  element={
                    <RequireIsVideoLabelReviewer>
                      <LocationExceptionalStatusPage />
                    </RequireIsVideoLabelReviewer>
                  }
                />
              </Routes>
            </AltToggleModeProvider>
          </ProvideLabellingHotkeys>
        </ProvideScrapEyeMetadata>
      </RequirePermissions>
    </RequireFeatureFlagsPage>
  );
};
